// Cookie helper functions
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

const default_cars = [
  "BYD_Shark_2025+",
  "Chevrolet_Silverado 1500_2019+",
  "Chevrolet_Silverado 2500_2021+",
  "Ford_F150_2015+",
  "Ford_F150_2021+",
  "Ford_Ranger Super Duty_2026+",
  "Ford_Next-Gen Raptor_2022+",
  "Ford_Next-Gen Wildtrak_2022+",  
  "Ford_Next-Gen Ranger_2022+",
  "Ford_Ranger PX_2011-2022",
  "Ford_Wildtrak PX_2011-2020", 
  "Ford_Wildtrak PX (Electric cover)_2020-2022",
  "Ford_Raptor PX_2018-2022",
  "GWM_Cannon_2024+",
  "Holden_Colorado_2012-2020",
  "Isuzu_DMax_2012-2020",
  "Isuzu_DMax_2020+",
  "Isuzu_DMax Blade_2024+",
  "Isuzu_X-Terrain_2020+",
  "KIA_Tasman_2025+",
  "LDV_T60_2019+",
  "Mazda_BT50_2011-2020",
  "Mazda_BT50_2020+",
  "Mazda_BT50-SP_2020+",
  "Mercedes_X-Class_2017-2020",
  "Mitsubishi_MQ/MR_2015-2023",
  'Mitsubishi_MV GSR _2024+',
  'Mitsubishi_MV_2024+',
  "Nissan_Navara_2015-2020",
  "Nissan_Navara_2016-2025",
  "Toyota_Hilux (A deck)_2010-2015",
  "Toyota_Hilux (A deck)_2015-2025",
  "Toyota_Hilux (A deck)_2026+",
  "RAM_DT 1500_2019+",
  "RAM_2500_2021+",
  "SsangYong_Musso (Short Bed)_2018+",
  "SsangYong_Musso (Long Bed)_2019+",
  "Toyota_Tundra_2007-2021",
  "Toyota_Tundra_2022+",
  "Volkswagen_Amarok_2010-2023",
  "Volkswagen_Aventura_2017-2023",
  "Volkswagen_All-New Amarok_2023+",
  "Volkswagen_All-New Aventura_2023+",
];

class SelectCar extends HTMLElement {
    constructor() {
        super();
  
        this.cars = this.buildMap(this.getCars());
      
        this.setup();
    }

    getCars() {
        const parsed = JSON.parse(this.getAttribute('cars'));
      
        return parsed.length ? parsed : default_cars;
    }

    setup() {
        const selects = this.querySelectorAll('select');

        selects.forEach(select => {
            switch (select.dataset.select) {
                case 'make':
                    this.populateMake(select);
                    select.addEventListener('change', this.onSelectMake.bind(this));
                    break;
                case 'model':
                    select.addEventListener('change', this.onSelectModel.bind(this));
                    break;
                case 'year':
                    select.addEventListener('change', this.onSelectYear.bind(this));
                    break;
            }
        });

        // Handle form submission
        const form = this.querySelector('form');
        if (form) {
            form.addEventListener('submit', this.onFormSubmit.bind(this));
        }

        // Load from cookie on init
        this.loadFromCookie();
    }

    onFormSubmit(event) {
        event.preventDefault();
        
        const input = this.querySelector('[type="hidden"]');
        const carSelection = input.value;
        
        if (carSelection && this.getYear() !== "Select year") {
            // Save to cookie (30 days)
            setCookie('selected_car', carSelection, 30);
            
            // Redirect to collection with filter parameter
            const form = event.target;
            const url = new URL(form.action, window.location.origin);
            url.searchParams.set('filter.p.m.custom.make_model_year', carSelection);
            window.location.href = url.toString();
        }
    }

    loadFromCookie() {
        const savedCar = getCookie('selected_car');
        if (!savedCar) return;

        // Parse the saved car selection
        const [make, model, year] = savedCar.split('_');
        
        // Set the dropdowns
        const makeSelect = this.querySelector('[data-select="make"]');
        const modelSelect = this.querySelector('[data-select="model"]');
        const yearSelect = this.querySelector('[data-select="year"]');

        if (makeSelect && make) {
            makeSelect.value = make;
            this.populateModel();
            
            setTimeout(() => {
                if (modelSelect && model) {
                    modelSelect.value = model;
                    this.populateYear();
                    
                    setTimeout(() => {
                        if (yearSelect && year) {
                            yearSelect.value = year;
                            this.updateResult();
                        }
                    }, 50);
                }
            }, 50);
        }
    }

    onSelectMake(event) {
        console.log("Selected make:", event.target.value)
        this.populateModel();
        this.updateResult();
        
    }
    onSelectModel(event) {
        console.log("Selected model:", event.target.value);
        this.populateYear();
        this.updateResult();
    }

    onSelectYear(event) {
        console.log("Selected year:", event.target.value);
        this.updateResult();
    }

    checkAllIsSelected(){
      if(this.getYear() !== "Select year"){
        document.getElementById("selectButton").disabled = false;
        document.getElementById("selectButton").style.opacity = 1;
      }
    }

    updateResult() {
        const input = this.querySelector('[type="hidden"]');
        input.value = `${this.getMake()}_${this.getModel()}_${this.getYear()}`;
        this.checkAllIsSelected();
    }

    populateMake(select) {
        select.innerHTML = Object.keys(this.cars).reduce((html, make) => {
            return html += `<option value="${make}">${make}</option>`;
        }, '<option disabled selected>Select brand</option>');
    }

    populateModel() {
        const make = this.getMake();
        const select = this.querySelector('[data-select="model"]');

        select.innerHTML = Object.keys(this.cars[make]).reduce((html, model) => {
            return html += `<option value="${model}">${model}</option>`;
        }, '<option disabled selected>Select model</option>');

        select.disabled = false;
    }

    populateYear() {
        const make = this.getMake();
        const model = this.getModel();
        const select = this.querySelector('[data-select="year"]');

        select.innerHTML = this.cars[make][model].reduce((html, year) => {
            return html += `<option value="${year}">${year}</option>`;
        }, '<option disabled selected>Select year</option>');

        select.disabled = false;
    }

    getMake() {
        return this.querySelector('[data-select="make"]')?.value;
    }

    getModel() {
        return this.querySelector('[data-select="model"]')?.value;
    }

    getYear() {
        return this.querySelector('[data-select="year"]')?.value;
    }

    buildMap(cars) {
      
        return cars.reduce((map, current) => {
            const [make, model, year] = current.split('_');

            if (!map[make]) {
                map[make] = {};
            }

            if (!map[make][model]) {
                map[make][model] = [];
            }

            map[make][model].push(year);

            return map
        }, {});
    }
}

window.customElements.define('select-car', SelectCar);